import Axios from "axios";
import { HttpService } from "./HttpService";
import store from "app/store/store";

export class NoarLocaliseApiService extends HttpService {
  constructor(resource = "") {
    const instance = Axios.create({
      baseURL: `${process.env.REACT_APP_API_NOAR_LOCALISE}/api${
        resource ? "/" + resource : ""
      }`,
    });

    super(instance);
  }

  async makeHttpRequest(config: any) {
    const authData = this.getAuthData();
    const language = this.getLanguage();

    if (authData) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${authData.token}`,
        "Access-Control-Expose-Headers": "Content-Disposition",
        "Content-Language": language,
      };
    } else {
      config.headers = {
        ...(config.headers || {}),
        "Content-Language": language,
      };
    }

    return super.makeHttpRequest(config);
  }

  getLanguage() {
    const { i18n } = store.getState();
    if (i18n) {
      switch (i18n.lang) {
        case "pt":
          return "pt-BR";
        case "en":
          return "en-US";
        case "es":
          return "es-ES";
        default:
          return "en-US";
      }
    }

    return "en-US";
  }

  getAuthData() {
    const {
      auth: { authData },
    } = store.getState();

    return authData;
  }

  async generateTempUri(filePath: string, expirationTime: string) {
    try {
      const response = await this.makeHttpRequest({
        method: "GET",
        url: `/azure-blob/generate-temp-uri`,
        params: { filePath, expirationTime },
      });

      return { uri: response.data.uri };
    } catch (error) {
      console.error("Error generating: ", error);
      return { uri: "" };
    }
  }
}
